export default __webpack_public_path__ + "static/media/event.72720a52.svg";